import { SearchResults } from "@components/layout/section/search/searchResults.js";
import * as React from 'react';
export default {
  SearchResults,
  React
};